<template>
  <menu v-if="menu == 'default'" class="navigation-buttons">
    <div v-for="item in menuItems" v-show="item.menu_item" :key="item.id">
      <v-btn
        :to="item.home ? '/' : '/' + item.slug"
        v-bind="props"
        class="menu-item px-0"
        :class="`menu-item-${item.id} ${props.class}`"
        >{{ item.name }}</v-btn
      >
    </div>
  </menu>
  <menu v-else class="navigation-buttons">
    <div v-for="item in menuItems" :key="item.id">
      <component
        :is="
          item.children.length
            ? 'parent-vertical-menu-button'
            : `${item.type}-menu-button`
        "
        :props="props"
        :item="item"
        class="menu-item px-0"
        :class="`menu-item-${item.id} ${props.class}`"
      ></component>
    </div>
  </menu>
</template>

<script>
import { activeTemplate } from '@/graphql/template.gql'
import PageMenuButton from './PageMenuButton'
import SectionMenuButton from './SectionMenuButton'
import UrlMenuButton from './UrlMenuButton'
import ParentVerticalMenuButton from './ParentVerticalMenuButton'
import FileMenuButton from './FileMenuButton'

export default {
  name: 'BaseMenu',
  props: {
    menu: {
      type: String
    },
    props: {
      type: Object,
      required: true
    }
  },
  components: {
    PageMenuButton,
    SectionMenuButton,
    UrlMenuButton,
    ParentVerticalMenuButton,
    FileMenuButton
  },
  computed: {
    menuItems() {
      return this.menu == 'default'
        ? this.activeTemplate.pages
        : this.activeTemplate.menus
            .filter(menu => menu.id == this.menu)
            .map(menu => menu.parent_items)[0]
    }
  },
  apollo: {
    activeTemplate: {
      query: activeTemplate
    }
  }
}
</script>

<style scoped>
.menu-item.px-0.menu-active-style-default.v-btn {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
</style>
